import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { IVerifyCorrectAccountFormValues } from "../_interfaces/IVerifyCorrectAccountFormValues";
import VerifyCorrectAccount from "../../../components/Authentication/LinkVolunteerToOrganizationSteps/VerifyCorrectAccount";
import FormLoadingSpinner from "../../../components/Organization/VolunteerOpportunities/FormLoadingSpinner";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            position: 'relative'
        },
        alert: {
            margin: theme.spacing(1),
            flexGrow: 1,
        },
    }),
);

interface VerifyCorrectAccountFormProps {
    values: IVerifyCorrectAccountFormValues;
    onChange: (patch: Partial<IVerifyCorrectAccountFormValues>) => void;
    onSubmit: (overrideValues?: Partial<IVerifyCorrectAccountFormValues>) => void;
    isSubmitting?: boolean;
    error?: string;
    fieldErrors?: Partial<Record<keyof IVerifyCorrectAccountFormValues, string>>;
}

export const VerifyCorrectAccountForm: React.FC<VerifyCorrectAccountFormProps> = ({
    values,
    onChange,
    onSubmit,
    isSubmitting,
    error,
    fieldErrors,
}) => {

    /********** State **********/

    const getFormId = () => {
        return `form-verify-correct-account-${Date.now()}-${Math.random()}`;
    }

    const [formId] = useState(() => getFormId());

    /********** React hooks **********/

    const classes = useStyles();

    /********** Event handlers **********/

    const onFormSubmitted = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Prevent page reload
        event.stopPropagation();
        onSubmit();
    }

    /********** Render **********/

    return (
        <form onSubmit={onFormSubmitted} noValidate autoComplete="off" id={formId} className={classes.form}>
            {values.loading ? <FormLoadingSpinner /> : undefined}
            {error && <Alert severity="error" className={classes.alert}>{error}</Alert>}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <VerifyCorrectAccount
                        email={values.email}
                        usersName={values.userName}
                        prompt={values.prompt}
                        onConfirmed={() => onSubmit({ correctAccount: true })}
                        onLogoutClicked={() => onSubmit({ correctAccount: false })} />
                </Grid>
            </Grid>
        </form>
    );
};